export default {
    app: {
        name: 'Forecaster',
        title: 'Forecaster',
        loading: 'Caricamento...',
        error: 'Si è verificato un errore.',
        saved: 'Salvato',
        save: 'Salva',
    },
    home: {
        welcome: 'Benvenuto su Forecaster!',
        upcomingRain: 'Pioggia imminente',
        searchLocation: 'Cerca luogo',
        loadingData: 'Caricamento dati meteo...',
        findingLocation: 'Ricerca della posizione...',
        geolocationError: 'Impossibile ottenere la posizione corrente. Abilita i servizi di localizzazione o cerca una posizione.',
        offlineError: 'Sembra che tu sia offline. Controlla la tua connessione internet.',
        serverError: 'C\'è stato un problema di connessione al nostro server. Riprova più tardi.',
        forecastUnavailableError: 'Al momento non è disponibile una previsione aggiornata per questa località. Riprova più tardi.',
        currentLocation: 'Posizione attuale',
        fetchError: 'Impossibile caricare i dati meteo. Riprova più tardi.',
        retry: 'Riprova',
        byMetNo: 'Offerto da YR.no',
        byMeteoFrance: 'Offerto da Météo-France',
        byAppleWeather: 'Offerto da {appleIcon} Weather',
        byGoogleWeather: 'Offerto da Google Weather',
        validUntil: 'Valido fino alle {time}',
        loadedAt: 'Caricato alle {time}',
        currently: 'Al momento',
        thisWeek: 'Questa settimana',
        today: 'Oggi',
        tomorrow: 'Domani',
        geolocationErrorGeneric: 'Qualcosa è andato storto durante il rilevamento della tua posizione.',
        geolocationPermissionDenied: 'L\'accesso alla posizione è stato negato. Per continuare, consenti la condivisione della posizione nelle impostazioni del browser.',
        geolocationPositionUnavailable: 'Non siamo riusciti a determinare la tua posizione. Ciò potrebbe essere dovuto a un segnale debole o a servizi di localizzazione disattivati.',
        geolocationTimeout: 'Ci vuole troppo tempo per trovare la tua posizione. Riprova o controlla la tua connessione.',
        geolocationUnsupported: 'La posizione non è disponibile in questo browser o contesto. Usa HTTPS o cerca una località.',
        geolocationPromptRequired: 'Tocca Riprova per consentire l\'accesso alla posizione e continuare.',
        providerError: 'Impossibile caricare i dati da {providerName}. Potrebbero esserci dei problemi. Riprova più tardi.'
    },
    units: {
        precipitation: {
            mm: '{value} mm',
            in: '{value} in',
        },
    },
    drawer: {
        currentLocation: 'Posizione attuale',
        starredLocations: 'Luoghi preferiti',
        starToSave: 'Aggiungi un luogo ai preferiti per salvarlo qui.',
        settings: 'Impostazioni',
        colorGuide: 'Guida colori',
        feedback: 'Invia feedback',
        helpTranslate: 'Aiuta a tradurre',
    },
    colorGuide: {
        title: 'Guida colori',
        clear: 'Sereno',
        clear_explanation: 'Nessuna precipitazione prevista e meno del 25% del cielo verrà ricoperto da nuvole.',
        partly_cloudy: 'Parzialmente nuvoloso',
        partly_cloudy_explanation: 'Tra il 25% e il 75% del cielo verrà ricoperto da nuvole. Nessuna precipitazione prevista.',
        cloudy: 'Nuvoloso',
        cloudy_explanation: 'Più del 75% del cielo verrà ricoperto da nuvole. Nessuna precipitazione prevista.',
        scattered_rain: 'Pioggia sparsa',
        scattered_rain_explanation: 'Sarà presente della pioggia nella tua zona, ma non siamo sicuri se colpirà la tua posizione esatta.',
        rain: 'Pioggia',
        rain_explanation: 'C\'è una forte possibilità che piova.',
        scattered_snow: 'Neve sparsa',
        scattered_snow_explanation: 'Sarà presente della neve nella tua zona, ma non siamo sicuri se colpirà la tua posizione esatta.',
        snow: 'Neve',
        snow_explanation: 'C\'è una forte possibilità che nevichi.',
    },
    settings: {
        title: 'Impostazioni',
        wind_speed_units_default: 'kmh',
        temperature_units_default: 'celsius',
        night_mode_default: 'system',
        units: 'Unità',
        temperature_units: 'Temperatura',
        wind_speed_units: 'Vento',
        precipitation_units: 'Precipitazioni',
        forecast: 'Previsioni',
        hide_early_morning: 'Nascondi le prime ore del mattino',
        hide_early_morning_explanation: 'Mostra il meteo dalle 5 del mattino in poi invece delle 24 ore complete',
        appearance: 'Aspetto',
        theme: 'Tema',
        show_minMax: 'Mostra temperature min/max',
        show_minMax_summary: 'Mostra le temperature min/max giornaliere accanto alle informazioni su pioggia e nuvole',
        auto_expand_today: 'Espandi automaticamente le previsioni di oggi',
        about: 'Informazioni su',
        privacy_policy: 'Informativa sulla privacy',
        terms_of_service: 'Termini di servizio',
        provider: 'Provider',
        data_source: 'Fonte dati',
        language: 'Lingua',
        unit_selection: {
            celsius: 'Celsius',
            fahrenheit: 'Fahrenheit',
        },
        wind_speed_unit_selection: {
            mph: 'mph',
            knots: 'nodi',
            kmh: 'km/h',
            ms: 'm/s',
            beaufort: 'Scala di Beaufort',
        },
        precipitation_unit_selection: {
            mm: 'mm',
            inches: 'pollici',
        },
        night_mode_options: {
            system: 'Automatico',
            light: 'Chiaro',
            dark: 'Scuro',
        },
        data_source_options: {
            auto: 'Automatico',
            metno: 'YR.no',
            meteofrance: 'MeteoFrance',
            appleweather: 'Apple Weather',
            googleweather: 'Google Weather',
        },
        language_selection: {
            en: 'English',
            de: 'Deutsch',
            es: 'Español',
            fr: 'Français',
            it: 'Italiano',
        }
    },
    provider_modal: {
        title: 'Scegli la tua fonte meteo',
        close_modal: 'Chiudi selezione provider',
        cancel: 'Annulla',
        save: 'Salva',
        metno_desc: 'Previsioni globali affidabili dall\'Istituto Meteorologico Norvegese.',
        meteofrance_desc: 'Previsioni dettagliate ad alta risoluzione per la Francia.',
        appleweather_desc: 'Dati precisi ad alta risoluzione da Apple Weather.',
        googleweather_desc: 'Previsioni globali di alta qualità da Google.',
        auto_desc: 'Lascia che l\'app scelga automaticamente la fonte migliore per la tua posizione.',
    },
    searchModal: {
        searchForLocation: 'Cerca un luogo...',
        placeholder: 'Cerca un luogo',
        closeModal: 'Chiudi la ricerca',
        googleMapsError: 'Errore durante il caricamento della libreria Google Maps Places:',
        googleMapsNotLoaded: 'Libreria API JavaScript di Google Maps non caricata.',
        placesLibraryError: 'Libreria Places non completamente caricata o token di sessione mancante.',
        fetchPredictionsError: 'Errore nel recupero dei suggerimenti di luogo:',
        fetchDetailsError: 'Errore nel recupero dei dettagli del luogo:',
        noInput: 'Inizia a digitare per cercare luoghi.',
        noResults: 'Nessun risultato trovato.',
        noRecentlyViewed: 'Nessuna visualizzazione recente.',
        searchUnavailable: 'La ricerca non è disponibile perché i servizi Google sono bloccati da questo browser o dalla tua configurazione.',
        searching: 'Ricerca in corso...',
        recentlyViewed: 'Visti di recente',
    },
    minutelyTimeline: {
        now: 'Adesso',
        minutes: '{minutes}',
        minutesWithUnit: '{minutes} min',
    },
    upcomingRain: {
        maxIntensity: 'Forte',
        midIntensity: 'Moderata',
        minIntensity: 'Leggera',
    },
    weeklyForecast: {
        rainCloud: 'Pioggia e nuvole',
        temperature: 'Temperatura',
        wind: 'Vento',
    },
    feedback: {
        title: 'Ci piace ricevere feedback!',
        message: 'Il tuo feedback ci aiuta a migliorare Forecaster. Facci sapere cosa ne pensi!',
        featureIdeas: 'Hai un\'idea per una nuova funzionalità? Ci piacerebbe sentirla!',
        contactUs: 'Puoi contattarci a',
        send: 'Invia feedback',
    },
    forecastInfo: {
        details: 'Informazioni sulla previsione',
        explanation: 'Le previsioni del tempo vengono aggiornate periodicamente dai nostri provider.',
        computed: 'Generato dal provider',
        expires: 'Nuova previsione prevista',
        loaded: 'Scaricato',
        close: 'Chiudi',
    }
};
